"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var i18n_1 = require("./directives/i18n");
var TrimWhitespace_1 = require("./directives/TrimWhitespace");
var App_1 = require("./components/App");
vue_1.default.directive('trim-whitespace', {
    inserted: TrimWhitespace_1.trimEmptyTextNodes,
    componentUpdated: TrimWhitespace_1.trimEmptyTextNodes,
});
vue_1.default.directive('i18n', {
    inserted: i18n_1.translateTextNode,
    componentUpdated: i18n_1.translateTextNode,
});
new vue_1.default(App_1.mainAppSettings);
//# sourceMappingURL=script.js.map